import React from 'react';
import { Link } from 'react-router-dom';

const HeroSection = ({ title, subtitle, bgImage, cta1, cta2 }) => {
  return (
    <div className="relative h-[60vh] min-h-[500px] flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 z-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div className="absolute inset-0 bg-slate-900/60 mix-blend-multiply" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
        <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
          {title}
        </h1>
        <p className="text-xl md:text-2xl text-slate-200 mb-10 max-w-2xl mx-auto font-light">
          {subtitle}
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          {cta1 && (
            <Link to={cta1.link} className="bg-cyan-600 hover:bg-cyan-500 text-white font-semibold py-3 px-8 rounded-md transition-all shadow-lg hover:shadow-cyan-500/30">
              {cta1.text}
            </Link>
          )}
          {cta2 && (
            <Link to={cta2.link} className="bg-white hover:bg-slate-100 text-blue-900 font-semibold py-3 px-8 rounded-md transition-all shadow-lg">
              {cta2.text}
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeroSection;